import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1274ef2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5 mb-xl-10 px-3 px-xl-5 py-2 py-xl-5" }
const _hoisted_2 = {
  key: 0,
  class: "text-center mb-5"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center mb-5"
}
const _hoisted_4 = { class: "row gy-4 gy-xl-0 gx-xl-5" }
const _hoisted_5 = { class: "col-12 col-xl-4 order-xl-1" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center border-bottom pb-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/logos/hc.svg",
    class: "side-logo",
    alt: "Logo"
  })
], -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "border-bottom pb-3 fs-5"
}
const _hoisted_11 = { class: "row mt-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, " Preço total após a Black Friday ", -1))
const _hoisted_13 = { class: "col-6 text-end fs-2 fw-bold text-primary" }
const _hoisted_14 = { class: "text-danger" }
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, [
  /*#__PURE__*/_createTextVNode(" Desconto 72% "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("small", { class: "text-gray-500" }, [
    /*#__PURE__*/_createTextVNode("Apenas na Black Friday "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("para ex-alunos")
  ])
], -1))
const _hoisted_17 = { class: "col-4 text-end fw-bold text-danger text-decoration-line-through" }
const _hoisted_18 = { class: "row mt-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 pt-2" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "" }, " Preço Total ")
], -1))
const _hoisted_20 = { class: "col-8 text-end fw-bold text-success" }
const _hoisted_21 = {
  class: "text-1xl",
  style: {"font-size":"x-large"}
}
const _hoisted_22 = {
  key: 1,
  class: "border-bottom pb-3 fs-5"
}
const _hoisted_23 = { class: "row mt-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, " Valor à vista ", -1))
const _hoisted_25 = { class: "col-6 text-end fs-2 fw-bold text-primary" }
const _hoisted_26 = { class: "text-info fs-1" }
const _hoisted_27 = { class: "row mt-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 pt-2" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "" }, " Preço Total ")
], -1))
const _hoisted_29 = { class: "col-8 text-end fw-bold text-success" }
const _hoisted_30 = {
  class: "text-1xl",
  style: {"font-size":"x-large"}
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "border-bottom pb-3 fs-5 mt-2" }
const _hoisted_33 = { class: "border-bottom mt-3 fs-5" }
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "list-unstyled" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Acesso a todas as trilhas de aprendizado ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Curso de Web Hacking na Prática incluso ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Curso de Posicionamento e Comunicação ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Acesso a todos os outros cursos da plataforma ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Acesso a todos os mais de 200 laboratórios práticos ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Suporte técnico e humanizado pronto para te ajudar ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Acesso a nossa comunidade privada no Discord e participação em eventos exclusivos ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Acesso a todos os eventos ao vivo exclusivos para membros ")
const _hoisted_44 = { class: "col-12 col-xl-6 offset-xl-1 order-xl-0" }
const _hoisted_45 = {
  class: "card",
  style: {"min-height":"400px"}
}
const _hoisted_46 = { class: "card-body" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "text-center fs-4" }
const _hoisted_49 = { class: "fs-5 text-center mt-6" }
const _hoisted_50 = { class: "list-unstyled" }
const _hoisted_51 = { class: "text-gray-500" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Iugu Instituição de Pagamentos S.A.", -1))
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<div class=\"card mt-5\" data-v-1274ef2e><div class=\"card-body\" data-v-1274ef2e><div class=\"d-flex justify-content-center\" data-v-1274ef2e><div class=\"d-flex flex-column align-items-center\" data-v-1274ef2e><h3 class=\"text-gray-800 mt-3\" data-v-1274ef2e> Está com dificuldades no pagamento? </h3><p class=\"text-center text-gray-700\" data-v-1274ef2e> Entre em contato com nosso suporte para resolver qualquer problema. </p><p class=\"text-center text-gray-700\" data-v-1274ef2e> Atendimento via Whatsapp 👇 </p><div class=\"row\" data-v-1274ef2e><div class=\"col-md-2\" data-v-1274ef2e><small class=\"bi bi-whatsapp fs-1 text-success\" data-v-1274ef2e></small></div><div class=\"col-md-10\" data-v-1274ef2e><p class=\"text-left text-gray-700\" data-v-1274ef2e><b data-v-1274ef2e>Clique no número:</b> <br data-v-1274ef2e><a href=\"https://api.whatsapp.com/send?phone=+5511944562077&amp;text=Olá,%20tenho%20uma%20dúvida%20sobre%20o%20Hacking%20Club!\" target=\"_blank\" data-v-1274ef2e>+55 11 94456-2077</a></p></div></div></div></div></div></div>", 1)
const _hoisted_54 = { class: "row d-flex items-center justify-content-center right-0" }
const _hoisted_55 = { class: "col-lg-10 px-2" }
const _hoisted_56 = { class: "card" }
const _hoisted_57 = { class: "card-header align-items-center border-0 mt-4" }
const _hoisted_58 = { class: "card-title align-items-start flex-column" }
const _hoisted_59 = { class: "fw-bolder text-dark" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, null, -1))
const _hoisted_61 = { class: "card-body pt-3" }
const _hoisted_62 = { class: "d-flex flex-row-fluid align-items-center flex-wrap my-lg-0 me-2" }
const _hoisted_63 = { class: "flex-grow-1 my-lg-0 my-2 me-2" }
const _hoisted_64 = {
  href: "#",
  class: "text-gray-800 fw-bolder text-hover-primary fs-6"
}
const _hoisted_65 = { class: "text-gray-600 fw-bold d-block pt-1" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("link", {
    rel: "stylesheet",
    href: "https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"
  }),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://api.whatsapp.com/send?phone=+5511944562077&text=Olá,%20tenho%20uma%20dúvida%20sobre%20o%20Hacking%20Club!",
    class: "float",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-whatsapp my-float text-white" })
  ])
], -1))

import Timeline from "@/views/crafted/checkout/components/Timeline.vue";
import {computed, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import PaymentListItem from "@/views/crafted/checkout/components/PaymentListItem.vue";
import CreditCardPayment from "@/views/crafted/checkout/components/CreditCardPayment.vue";
import BoletoPayment from "@/views/crafted/checkout/components/BoletoPayment.vue";
import PixPayment from "@/views/crafted/checkout/components/BoletoPixPayment.vue";
import CreditCardCheckout from "@/views/crafted/checkout/components/CreditCardCheckout.vue";
import BoletoPixPayment from "@/views/crafted/checkout/components/BoletoPixPayment.vue";
import BoletoCheckout from "@/views/crafted/checkout/components/BoletoCheckout.vue";
import PixCheckout from "@/views/crafted/checkout/components/PixCheckout.vue";
import LiCheckout from "@/components/common/li/LiCheckout.vue";
import ApiService from "@/core/services/ApiService";
import { Actions } from "@/store/enums/StoreEnums";
import { install } from "element-plus";
import { useI18n } from 'vue-i18n';



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const user = computed(() => store.getters.currentUser);
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const faq = ref([]);

const step = ref("main")
const timelineStep = ref(1)
const is_trooper = ref(false) as any


store.dispatch(Actions.GET_INSTALLMENTS, 2)
const installmentsData = computed(() => store.getters.getInstallmentData)
is_trooper.value = computed(() => {

  return installmentsData.value.is_trooper;
})

const calculateInstallments = (installmentsData) => {
  let installmentsList = [];
  for (let i = 1; i <= 12; i++) {
    if (installmentsData.installments && installmentsData.installments.hasOwnProperty(i.toString())) {
      let installmentValue = parseInt(installmentsData.installments[i], 10) / 100;


      const value = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(installmentValue);


      installmentsList.push({
        value: i,
        label: `${i}x de ${value}`
      });
    }
  }
  return installmentsList;
}

const installments = computed(() => {

  return calculateInstallments(installmentsData.value)
});


store.dispatch('loadPlan')




const formatValue = (value: string, discount: boolean) => {
  if (discount) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((value / 100 - ((value / 100) * 0.3)))
  } else {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((value / 100))
  }

}

const finishPayment = (nextStep) => {
  step.value = nextStep
  timelineStep.value = 2
}

const faqQuestions = (language: string) => {
  return [
    {
      image: "/media/stock/600x400/img-17.jpg",
      title: t(`${language}.checkout.asked.what_is_the_course_workload`),
      desc: t(`${language}.checkout.asked.what_is_the_course_workload_response`),
    },
    {
      image: "/media/stock/600x400/img-17.jpg",
      title: t(`${language}.checkout.asked.access_time`),
      desc: t(`${language}.checkout.asked.access_time_response`),
    },
    {
      image: "/media/stock/600x400/img-1.jpg",
      title: t(`${language}.checkout.asked.how_do_challenges_work`),
      desc:t(`${language}.checkout.asked.how_do_challenges_work_response`),
    },
    {
      image: "/media/stock/600x400/img-9.jpg",
      title: t(`${language}.checkout.asked.how_does_support_work`),
      desc:t(`${language}.checkout.asked.how_does_support_work_response`),
    },
    {
      image: "/media/stock/600x400/img-9.jpg",
      title: t(`${language}.checkout.asked.how_does_the_guarantee_work`),
      desc: t(`${language}.checkout.asked.how_does_the_guarantee_work_response`),
    },
    {
      image: "/media/stock/600x400/img-9.jpg",
      title: t(`${language}.checkout.asked.how_does_certification_work`),
      desc:t(`${language}.checkout.asked.how_does_certification_work_response`),
    }
  ]
};

const updateFaq = (language: string) => {
  //@ts-ignore
  faq.value = faqQuestions(language);
}

updateFaq(currentLanguage.value);

watch(() => currentLanguage.value,  (newLanguage) => {
  updateFaq(newLanguage)
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(user).is_premium)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.checkout.renew_your_plan`)), 1))
        : (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.checkout.upgrade_your_plan`)), 1)),
      _createVNode(Timeline, { step: timelineStep.value }, null, 8, ["step"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              (_unref(store).getters.getPlan.value_cents && _unref(installments))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_unref(is_trooper).value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, _toDisplayString(formatValue('499700', false)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("div", _hoisted_17, _toDisplayString(formatValue('360000', false)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(installments).slice(-1)[0]['label']), 1)
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, _toDisplayString(formatValue('499700', false)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(installments).slice(-1)[0]['label']), 1)
                            ])
                          ])
                        ]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.loading`)) + "... ", 1)
                  ])),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.checkout.side_menu_right.what_you_can_access`)) + ": ", 1),
                _createElementVNode("ul", _hoisted_35, [
                  _createVNode(LiCheckout, null, {
                    default: _withCtx(() => [
                      _hoisted_36
                    ]),
                    _: 1
                  }),
                  _createVNode(LiCheckout, null, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  }),
                  _createVNode(LiCheckout, null, {
                    default: _withCtx(() => [
                      _hoisted_38
                    ]),
                    _: 1
                  }),
                  _createVNode(LiCheckout, null, {
                    default: _withCtx(() => [
                      _hoisted_39
                    ]),
                    _: 1
                  }),
                  _createVNode(LiCheckout, null, {
                    default: _withCtx(() => [
                      _hoisted_40
                    ]),
                    _: 1
                  }),
                  _createVNode(LiCheckout, null, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 1
                  }),
                  _createVNode(LiCheckout, null, {
                    default: _withCtx(() => [
                      _hoisted_42
                    ]),
                    _: 1
                  }),
                  _createVNode(LiCheckout, null, {
                    default: _withCtx(() => [
                      _hoisted_43
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              (step.value == 'main')
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("h2", _hoisted_48, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.messages.hi`)) + ", " + _toDisplayString(_unref(user).nick || 'No nick'), 1),
                    _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.checkout.choose_the_payment_method`)), 1),
                    _createElementVNode("ul", _hoisted_50, [
                      _createVNode(PaymentListItem, {
                        title: _ctx.$t(`${_unref(currentLanguage)}.common.credit_card`),
                        icon: "/media/payment-methods/creditcard.svg",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (step.value = 'credit_card'), ["stop"]))
                      }, null, 8, ["title"]),
                      _createVNode(PaymentListItem, {
                        title: "Boleto",
                        icon: "/media/payment-methods/barcode.svg",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (step.value = 'boleto'), ["stop"]))
                      }),
                      _createVNode(PaymentListItem, {
                        title: "PIX",
                        icon: "/media/payment-methods/pix.svg",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (step.value = 'pix'), ["stop"]))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.checkout.payment_methods_are_processed_by`)) + " ", 1),
                      _hoisted_52
                    ])
                  ]))
                : _createCommentVNode("", true),
              (step.value == 'credit_card')
                ? (_openBlock(), _createBlock(CreditCardPayment, {
                    key: 1,
                    onGoBack: _cache[3] || (_cache[3] = ($event: any) => (step.value = 'main')),
                    onFinish: _cache[4] || (_cache[4] = ($event: any) => (finishPayment('cc_checkout')))
                  }))
                : _createCommentVNode("", true),
              (step.value == 'boleto')
                ? (_openBlock(), _createBlock(BoletoPixPayment, {
                    key: 2,
                    type: "boleto",
                    onGoBack: _cache[5] || (_cache[5] = ($event: any) => (step.value = 'main')),
                    onFinish: _cache[6] || (_cache[6] = ($event: any) => (finishPayment('boleto_checkout')))
                  }))
                : _createCommentVNode("", true),
              (step.value == 'pix')
                ? (_openBlock(), _createBlock(BoletoPixPayment, {
                    key: 3,
                    type: "pix",
                    onGoBack: _cache[7] || (_cache[7] = ($event: any) => (step.value = 'main')),
                    onFinish: _cache[8] || (_cache[8] = ($event: any) => (finishPayment('pix_checkout')))
                  }))
                : _createCommentVNode("", true),
              (step.value == 'cc_checkout')
                ? (_openBlock(), _createBlock(CreditCardCheckout, { key: 4 }))
                : _createCommentVNode("", true),
              (step.value == 'boleto_checkout')
                ? (_openBlock(), _createBlock(BoletoCheckout, { key: 5 }))
                : _createCommentVNode("", true),
              (step.value == 'pix_checkout')
                ? (_openBlock(), _createBlock(PixCheckout, { key: 6 }))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_53
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("h3", _hoisted_58, [
              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.checkout.asked.frequently_asked_questions`)), 1),
              _hoisted_60
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{ 'mb-7': faq.value.length - 1 !== index }, "d-flex align-items-sm-center"])
              }, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("a", _hoisted_64, _toDisplayString(item.title), 1),
                    _createElementVNode("span", _hoisted_65, _toDisplayString(item.desc), 1)
                  ])
                ])
              ], 2))
            }), 128))
          ])
        ])
      ])
    ]),
    _hoisted_66
  ], 64))
}
}

})